import React, { useState } from "react";

const Page1 = () => {
  const [result, setResult] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const url = process.env.REACT_APP_API_URL;
  const version = process.env.REACT_APP_VERSION;
  const env = process.env.REACT_APP_ENV;

  const handleFetch = async () => {
    setLoading(true);
    setError("");
    setResult("");

    try {
      const helloUrl = process.env.NODE_ENV === 'development'
        ? '/hello'
        : `${process.env.REACT_APP_API_URL}/hello`;
      const response = await fetch(helloUrl);

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.text(); // ⬅️ Changed from .json() to .text()
      setResult(JSON.stringify(data, null, 2));
    } catch (err: any) {
      setError(`❌ Error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "2rem" }}>
      <h1>Page 1</h1>
      <h1>Welcome to Page 1 (V2)</h1>
      <h2>url={url}</h2>
      <h2>version={version}</h2>
      <h2>env={env}</h2>
      <button
        onClick={handleFetch}
        disabled={loading}
        style={{
          padding: "0.5rem 1rem",
          fontSize: "1rem",
          cursor: loading ? "not-allowed" : "pointer",
        }}
      >
        {loading ? "Loading..." : "Fetch API"}
      </button>

      {error && <p style={{ color: "red", marginTop: "1rem" }}>{error}</p>}

      {result && (
        <pre
          style={{
            marginTop: "1rem",
            padding: "1rem",
            backgroundColor: "#f4f4f4",
            borderRadius: "8px",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
          }}
        >
          {result}
        </pre>
      )}
    </div>
  );
};

export default Page1;
